import { Autocomplete, Box, Button, TextField, } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import GlobalDialogContent from '../GlobalDialogContent';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../redux/store';
import { closeDialog } from '../../../redux/reducer/dialogSlice';
import { RoleListService, UpdateUserStatusService } from '../../../utils/services/registration/donor-registration.service';
import { showSnackbar } from '../../../redux/reducer/snackbarSlice';
import { setModuleRefresh } from '../../../redux/reducer/registration/RefreshSlice';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function UserApprovalDialog() {
    const dispatch = useDispatch();
    const { status, payload } = useSelector((state: RootState) => state.dialog);
    const uuid = payload?.uuid;
    const registrationType = payload?.registrationType;
    const [searchParams] = useSearchParams();
    const type = searchParams.get("type");
    const [selectedRoleId, setSelectedRoleId] = useState<string>('');
    const [roleList, setRoleList] = useState<any>([])
    const [loading, setLoading] = useState(false);
    const validationSchema = Yup.object().shape({
        comments: Yup.string().required('Comments are required'),
        role: Yup.lazy((value) => {
            return payload?.registrationType === "government_user" && status !== "Compliance" && status !== "Rejected"
                ? Yup.string().required('Role is required')
                : Yup.string().notRequired();
        }),
    });

    const fetchRoleList = async () => {
        const reqPayload = {
            "sortBy": "name",
            "orderBy": "DESC",
            "limit": 20,
            "offset": 0
        }
        const { code, data } = await RoleListService(reqPayload);
        if (code === 200 && data?.data) {
            if (code === 200 && data) {
                const GovRoles = data?.data?.filter(
                    (item: any) => item.user_type === "department" || item.user_type === "csr_cell" || item.user_type === 'administration'
                );
                const DonorRoles = data?.data?.filter(
                    (item: any) => item.user_type === "donor"
                );
                const AgnecyRoles = data?.data?.filter(
                    (item: any) => item.user_type === "implementing_agency"
                );
                if (type === 'government_user') {
                    setRoleList(GovRoles);
                } else if (type === 'donor') {
                    setRoleList(DonorRoles);
                } else if (type === 'implementing_agency') {
                    setRoleList(AgnecyRoles);
                } else {
                    setRoleList([]);
                }
            }
        } else {
            setRoleList([]);
        }
    }

    return (
        <GlobalDialogContent
            dialogBody={
                <Formik
                    initialValues={{ comments: '', role: '' }}
                    validationSchema={validationSchema}
                    onSubmit={async (values, { setSubmitting }) => {
                        setLoading(true);
                        const submitPayload = {
                            entity_type: registrationType,
                            uuid: uuid,
                            status: status?.toLowerCase() === "approve" ? "approved" : status?.toLowerCase() === "compliance" ? "compliance" : "rejected",
                            updated_by: payload?.updated_by || 1,
                            comments: values.comments,
                            ...(registrationType === "government_user" && status !== 'Compliance' && { role_id: Number(selectedRoleId) }),
                        };
                        const { code, message } = await UpdateUserStatusService(submitPayload);
                        setLoading(false);
                        if (code === 200) {
                            dispatch(closeDialog());
                            dispatch(setModuleRefresh({ moduleName: 'user_details', refresh: true }));
                            dispatch(showSnackbar({ type: 'success', message: message || 'Status Updated Successfully' }));
                        } else {
                            dispatch(showSnackbar({ type: 'error', message: message || 'Something Went Wrong ,Please try again' }));

                        }
                    }}
                >
                    {({ errors, touched, isSubmitting, setFieldValue }) => (
                        <Form id="user-approval-form">
                            {(status !== 'Compliance' && status !== 'Rejected' && payload?.registrationType === "government_user") && <Box mb={2}>
                                <Autocomplete
                                    onOpen={fetchRoleList}
                                    size='small'
                                    options={roleList}
                                    getOptionLabel={(option) => option.name}
                                    value={roleList.find((role: any) => role.id === selectedRoleId) || null}
                                    onChange={(_, newValue) => {
                                        setSelectedRoleId(newValue?.id || '');
                                        setFieldValue('role', newValue?.name || '');
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Assign Role *"
                                            error={touched.role && Boolean(errors.role)}
                                            helperText={touched.role && errors.role}
                                            fullWidth
                                        />
                                    )}
                                />
                            </Box>
                            }
                            <Box mb={2}>
                                <Field
                                    as={TextField}
                                    name="comments"
                                    label="Comments *"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    error={touched.comments && Boolean(errors.comments)}
                                    helperText={touched.comments && errors.comments}
                                />
                            </Box>
                        </Form>
                    )}
                </Formik>
            }
            dialogFooter={
                <Button
                    disabled={loading}
                    type="submit"
                    variant="contained"
                    color={status === 'Approve' ? 'success' : status === 'Compliance' ? "secondary" : "error"}
                    form="user-approval-form"
                >
                    {loading ? 'Loading...' : status}
                </Button>
            }
        />
    );
}